"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateString = exports._toNumber = exports.NumberString = exports.ObjectId = void 0;
const z = require("zod");
const _ = require("lodash");
const bson = require("bson");
exports.ObjectId = z.preprocess((obj) => bson.ObjectId.isValid(obj) ? obj.toString() : obj, z.string()).refine((d) => bson.ObjectId.isValid(d) && d, (d) => ({ message: `Cannot parse input as ObjectId: ${d}`, path: ['ObjectId'] }));
exports.NumberString = z.preprocess(_toNumber, z.number());
function _toNumber(data) {
    if (_.isEmpty(data)) {
        return data;
    }
    const asNumber = Number(data);
    if (_.isNaN(asNumber)) {
        return data;
    }
    return asNumber;
}
exports._toNumber = _toNumber;
function _toDate(data) {
    if (data instanceof Date) {
        return data;
    }
    return new Date(z.string().parse(data));
}
exports.DateString = z.preprocess(_toDate, z.date());
//# sourceMappingURL=UtilTypes.js.map